/**
 * Function that returns the value of a cookie
 * {@link https://bit.ly/34cDU2F}.
 * @param {string} a - cookie name.
 * @return {string} - Returns the cookie value or '' if not found.
 */
export function getCookie(a) {
  const b = document.cookie.match(`(^|[^;]+)\\s*${a}\\s*=\\s*([^;]+)`);
  return b ? b.pop() : '';
}
